import React, { Fragment, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import { Switch } from "react-router-dom"
import ProtectedRoute from "components/ProtectedRoute"
import AdminHeader from "components/AdminHeader"
import BottomNav from "components/BottomNav"
import Feed from "./Feed"
import Submitted from "./Submitted"
import Published from "./Published"
import Post from "./Post"
import CreatePost from "./CreatePost"
import AddOrg from "./AddOrg"
import { getCurrentOrg } from "actions/organization"

const App = ({ classes }) => {
  const dispatch = useDispatch()
  const currentOrgId = useSelector(state => state.organization.currentOrg.id)
  useEffect(() => {
    // Check if user belongs to current org and set in redux
    if (!currentOrgId) {
      dispatch(getCurrentOrg()).catch(error => console.log("ERROR:", error))
    }
  }, [])
  const onCreatePage = window.location.pathname === "/app/create"
  return (
    <Fragment>
      <AdminHeader />
      <Switch>
        <ProtectedRoute exact path="/app/" component={Feed} />
        <ProtectedRoute exact path="/app/feed" component={Feed} />
        <ProtectedRoute exact path="/app/submitted" component={Submitted} />
        <ProtectedRoute exact path="/app/published" component={Published} />
        <ProtectedRoute exact path="/app/post/" component={Post} />
        <ProtectedRoute exact path="/app/create" component={CreatePost} />
        <ProtectedRoute exact path="/app/add-org" component={AddOrg} />
      </Switch>
      {!onCreatePage && <BottomNav />}
    </Fragment>
  )
}

export default withStyles(styles)(App)



// WEBPACK FOOTER //
// ./src/pages/App/index.jsx